<template>
  <div>
    <b-form-group :label="label" :label-cols="3" class="mb-3">
      <b-form-input
        v-model="form.name"
        type="text"
        class="form-control"
        placeholder="Field Name"
        autocomplete="field_name"
        :state="vuelidate.name.$dirty ? !vuelidate.name.$invalid : null"
      />
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'CustomerFieldFormGroup',
  props: {
    customer_field: {
      type: Object,
      default: () => {}
    },
    vuelidate: {
      type: Object,
      default: () => {}
    },
    label: {
      type: String,
      default: 'Field'
    }
  },
  data () {
    return {
      form: {
        name: null
      }
    }
  },
  watch: {
    form: {
      handler () {
        this.$emit('onChange', this.form)
      },
      deep: true
    },
    'vuelidate.name.$model': {
      handler () {
        this.form.name = this.vuelidate.name.$model
      },
      immediate: true
    }
  },
  created () {
    this.fillForm()
  },
  methods: {
    fillForm () {
      if (this.customer_field) {
        for (const i in this.form) {
          if (this.customer_field[i]) {
            this.form[i] = this.customer_field[i]
          }
        }
      }
    }
  }
}
</script>
